import {commonInitialState} from "./common_store";

function initialState() {
    return {...commonInitialState}
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filter: state => state.filter,
    query: state => state.query,
    country: state => state.country,
    totalNumber: state => state.totalNumber
}

const actions = {
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setServerPagination(state, item) {
        state.serverPagination = item
    },
    setTotalNumber(state, item) {
        state.totalNumber = item
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilter(state, item) {
        state.filter = item
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
